<template>
  <v-alert dense prominent type="success">登录授权中</v-alert>
</template>
<script>
import { default as AuthApi } from "../../api/smp/auth/Auth.js";
import { default as AuthUtil } from "../../util/auth.js";
export default {
  name: "Auth",
  data() {
    return {
      authApi: AuthApi,
      authUtil: AuthUtil,
    };
  },
  watch: {
    $route: {
      handler(route) {
        this.tokenId = route.query.tokenId;
      },
      immediate: true,
    },
  },
  created() {
    this.auth();
  },
  methods: {
    auth() {
      let me = this;
      if (!me.tokenId) {
        me.errMsg("错误", "未获取到oa登录token");
        return;
      }
      me.authApi.oaLogin(me.tokenId).then((resp) => {
        let data = resp.data;
        if (!data || !data.code || data.code != 200) {
          me.$router.push({ path: "/login" });
          return;
        }
        if (
          !data.data.tokenInfo ||
          !data.data.tokenInfo.access_token ||
          data.data.tokenInfo.access_token == ""
        ) {
          me.$router.push({ path: "/login" });
          return;
        }
        let accessToken = data.data.tokenInfo.access_token;
        me.authUtil.setAccessToken(accessToken);
        me.$router.push({ path: "/main" });
      });
    },
    async errMsg(title, text) {
      await this.$dialog.error({
        text: text,
        title: title,
      });
    },
  },
};
</script>